<template>
	<div>
		<div class="top">员工入职</div>
		<el-button
			style="float: right; height: 40px; margin-top: -30px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
			@click="Return">返回</el-button>
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
			<div
				style="height:650px;background-color:white;margin:10px 40px 0 40px;padding:50px 100px;overflow-x: hidden">
				<span style="color:#006E4B;font-weight:900;font-size:20px">|</span>
				<span style="font-size:20px;font-weight:700">基本信息</span>
				<el-row>
					<el-col :span="12">
						<el-form-item label="姓名" prop="staff.staff_name" style="margin-top:40px;width:80%">
							<el-input v-model="ruleForm.staff.staff_name" placeholder="请输入姓名"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="性别" prop="staff.staff_gender" style="margin-top:40px">
							<el-radio v-model="ruleForm.staff.staff_gender" label="1">男</el-radio>
							<el-radio v-model="ruleForm.staff.staff_gender" label="0">女</el-radio>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="12">
						<el-form-item label="身份证号码" prop="staff.staff_card">
							<el-input v-model="ruleForm.staff.staff_card" type="number" placeholder="请输入身份证号码"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="手机号码" prop="staff.staff_telephone">
							<el-input v-model="ruleForm.staff.staff_telephone" type="number" placeholder="请输入手机号码"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="12">
						<el-form-item label="本人照片">
							<el-upload class="avatar-uploader" :action="$globals.http + '/file/upload'"
								:show-file-list="false" :on-success="handleStaffTelephoneSuccess">
								<img v-if="ruleForm.staff.staff_photo" :src="ruleForm.staff.staff_photo" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="身份证原件相片" prop="staff.card_photo">
							<el-upload class="avatar-uploader" :action="$globals.http + '/file/upload'"
								:show-file-list="false" :on-success="handleCardPhotoSuccess">
								<img v-if="ruleForm.staff.card_photo" :src="ruleForm.staff.card_photo" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="12">
						<el-form-item label="银行卡号">
							<el-input v-model="ruleForm.staff.bank_no" type="number" placeholder="请输入银行卡号"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="开户行">
							<el-select v-model="ruleForm.staff.opening_bank" style="width:100%" placeholder="请选择开户行"
                                clearable>
                                <el-option v-for="item in causeList" :key="item.id" :label="item.bank_name "
                                    :value="item.id">
                                </el-option>
                            </el-select>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="12">
						<el-form-item label="银行卡照片">
							<el-upload class="avatar-uploader" :action="$globals.http + '/file/upload'"
								:show-file-list="false" :on-success="handleBankPhotoSuccess">
								<img v-if="ruleForm.staff.bank_photo" :src="ruleForm.staff.bank_photo" class="avatar">
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</el-col>
					<el-col :span="12">

					</el-col>
				</el-row>

				<div>
					<span style="color:#006E4B;font-weight:900;font-size:20px;">| </span>
					<span style="font-size:20px;font-weight:700">入职信息</span>
					<el-row>
						<el-col :span="12">
							<el-form-item label="组织架构" prop="staff.organize_temporary_ids" style="width:100%">
								<el-cascader v-model="ruleForm.staff.organize_temporary_ids" @change="changeCascader"
									style="width:100%" collapse-tags :props="props">
								</el-cascader>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="城市" prop="staff.city_id" style="width:100%">
								<el-select v-model="ruleForm.staff.city_id" placeholder="请选择" style="width:100%">
									<el-option v-for="item in $globals.cityList" :key="item.city" :label="item.city"
										:value="item.city">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="职位" prop="staff.post_id" style="width:100%">
								<el-select v-model="ruleForm.staff.post_id" placeholder="请选择" style="width:100%">
									<el-option v-for="item in gwlist" :key="item.id" :label="item.post_name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="入职日期" prop="induction_time" style="width:100%">
								<el-date-picker v-model="ruleForm.induction_time" type="date" style="width:100%"
									value-format="yyyy-MM-dd" placeholder="选择日期">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="入职薪酬" prop="induction_salary" style="width:100%">
								<el-input type="number"
								 v-model="ruleForm.induction_salary" placeholder="请输入入职薪酬" style="width:100%">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="试用期时间" style="width:100%">
								<el-date-picker v-model="ruleForm.trial_start" type="date" placeholder="选择日期"
									value-format="yyyy-MM-dd" style="width:47%">
								</el-date-picker>
								—
								<el-date-picker v-model="ruleForm.trial_end" type="date" placeholder="选择日期"
									value-format="yyyy-MM-dd" style="width:47%">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="是否有试用期" style="width:100%">
								<el-select v-model="ruleForm.is_trial" style="width:100%">
									<el-option v-for="item in option" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="入职添加日期" style="width:100%">
								<el-input v-model="ruleForm.induction_date" disabled style="width:100%"></el-input>
							</el-form-item>
						</el-col>
					</el-row>


					<el-row>
						<el-col :span="12">
							<el-form-item label="试用期薪资" style="width:100%">
								<el-input
								v-model="ruleForm.trial_salary" placeholder="请输入试用期薪资" style="width:100%">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="入职资料套表">
								<el-button style="font-size:10px; height: 30px; text-align:center" size="small"
									type="goon">下载附件</el-button>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="签约合同上传">
								<el-upload class="upload-demo" :action="$globals.http + '/file/upload'" multiple
									:file-list="fileList" :on-success="handleAvatarSuccess" :on-remove="handleRemove">
									<el-button style="font-size:10px; height: 30px; text-align:center" size="small"
										type="goon">附件上传</el-button>
								</el-upload>
							</el-form-item>
						</el-col>
					</el-row>
					<el-form-item style="margin-left:200px">
                        <el-button type="goon" @click="isBlacklist()"
                            v-show="ruleForm.id === null || ruleForm.id === ''">保存</el-button>
                        <el-button type="goon" @click="Update()"
                            v-show="ruleForm.id != null && ruleForm.id != ''">修改</el-button>
                    </el-form-item>
				</div>
			</div>
		</el-form>

		<!-- <el-dialog title="返聘" :visible.sync="dialogVisible" width="30%" center>
			<span class="sp">当前人员在公司已有工作记录</span>
			<div class="fp">
				<div class="top1">
					<p>离职信息</p>
				</div>
				<div class="bottom">
					<span class="time">上次离职时间:{{isBlacklistData.remove_date}}</span>
					<br>
					<span class="is">是否黑名单:{{isBlacklistData.effective == '1' ? '否' : '是'}}</span>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="auditor">确 定</el-button>
			</span>
		</el-dialog> -->

		<!-- <el-dialog title="选择审核人" :visible.sync="dialogAuditorVisible" width="40%" :center="true"
			:close-on-click-modal="false">
			<SelectAuditor ref="SelectAuditor" :type="11" :examineDetailsList="ruleForm.examineDetailsList"
				:id="ruleForm.id">
			</SelectAuditor>
		</el-dialog> -->

	</div>
</template>

<script>
	import SelectAuditor from '../SelectAuditor/SelectAuditor.vue';
	export default {
		// components: {
		// 	SelectAuditor: SelectAuditor,
		// },
		props: ["ruleForm", "postList"],
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			var checkPhone = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入手机号！'));
				} else {
					const reg = /^1[3456789]\d{9}$/;
					console.log(reg.test(value));
					if (reg.test(value)) {
						callback();
					} else {
						return callback(new Error('手机号格式错误！'));
					}
				}
			};
			var checkSfz = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请输入身份证号码'));
				} else {
					const reg =
						/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
					console.log(reg.test(value));
					if (reg.test(value)) {
						callback();
					} else {
						return callback(new Error('身份证格式错误'));
					}
				}
			};
			return {
				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: false,
				},
				gwlist:[],
				// 开户行
				causeList:[],

				//表单验证
				rules: {
					'staff.staff_name': [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					'staff.staff_gender': [{
						required: true,
						message: '请选择性别！',
						trigger: 'blur'
					}],
					'staff.staff_card': [{
						required: true,
						validator: checkSfz,
						trigger: 'blur'
					}],
					'staff.staff_telephone': [{
						required: true,
						validator: checkPhone,
						trigger: 'blur'
					}],
					'staff.card_photo': [{
						required: true,
						message: '请上传身份证原件照片',
						trigger: 'blur'
					}],
					'staff.city_id': [{
						required: true,
						message: '请选择城市',
						trigger: 'blur'
					}],
					'staff.organize_temporary_ids': [{
						required: true,
						message: '请选择组织架构',
						trigger: 'blur'
					}],
					'staff.post_id': [{
						required: true,
						message: '请选择职位',
						trigger: 'blur'
					}],
					induction_salary: [{
						required: true,
						message: '请输入入职薪资！',
						trigger: 'blur'
					}],
					induction_time: [{
						required: true,
						message: '请选择入职时间！',
						trigger: 'blur'
					}]
				},

				//员工返聘数据
				isBlacklistData: {
					remove_date: '',
					effective: '',
				},

				//试用期数据
				option: [{
						value: '1',
						label: '否',
					},
					{
						value: '0',
						label: '是',
					}
				],

				//文件上传数据
				fileList: [],

				//审批审批流数据
				examineDetailsList: [],

				//页面相关
				dialogVisible: false,
				dialogAuditorVisible: false

			};
		},
		methods: {
			//本人照片上传
			handleStaffTelephoneSuccess(res, file) {
				this.$props["ruleForm"].staff.staff_photo = res.data.fileUrl;
			},
			//身份证原件相片上传
			handleCardPhotoSuccess(res, file) {
				this.$props["ruleForm"].staff.card_photo = res.data.fileUrl;
			},
			//银行卡照片上传
			handleBankPhotoSuccess(res, file) {
				this.$props["ruleForm"].staff.bank_photo = res.data.fileUrl;
			},
			//签约合同上传
			handleAvatarSuccess(res, file, fileList) {
				this.fileList = fileList;
				this.$props["ruleForm"].contract_url = "";
				this.fileList.forEach(item => {
					this.$props["ruleForm"].contract_url += item.response.data.fileUrl + ";"
				});
			},
			//签约合同移除
			handleRemove(file, fileList) {
				this.fileList = fileList;
			},
			//组织架构选择
			changeCascader() {
				this.$props["ruleForm"].staff.organize_ids = '';
				this.$props["ruleForm"].staff.organize_temporary_ids.forEach(item => {
					this.$props["ruleForm"].staff.organize_ids += item + ','
				})
				this.$props["ruleForm"].staff.project_id = this.$props["ruleForm"].staff.organize_temporary_ids[this
					.$props["ruleForm"].staff.organize_temporary_ids.length - 1];
					this.gwList();
			},
			//岗位
			async gwList() {
				var url = 'post/selectFind';
				var record = {
					organize_id: this.$props["ruleForm"].staff.project_id,
				};
                var res = await this.$globals.AxiosPost(url, record);
				this.gwlist = res.data;
			},
			//查询是否有入职记录
			isBlacklist() {
				this.$refs['ruleForm'].validate(async (valid) => {
					if (valid) {
						var url = 'StaffBlacklist/isBlacklist';
						var record = {
							staff_card:this.$props["ruleForm"].staff.staff_card,
						};
						var data = await this.$globals.AxiosPost(url, record);
						if (data === '-2000') {
							this.$message.error('服务器未响应！请稍后重试');
						} else {
							var code = data.code;
							var data = data.data;
							if (code === '200') {
								if (data.is_null == '0') {
									// this.auditor();
									this.Add()
								}else if(data.is_null == '2'){
									this.$message.error('当前员工已再本公司任职！');
								}else {
									this.$message.error('当前员工已再本公司有过任职记录！');
									this.isBlacklistData = data;
									this.dialogVisible = true;
								}
							} else {
								this.$message.warning(data);
							}
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			// //选择审核人
			// auditor() {
			// 	this.$props["ruleForm"].examineDetailsList = [];
			// 	this.dialogAuditorVisible = true;
			// 	this.$refs['SelectAuditor'].initialize();
			// },
			//添加
			async Add() {
				var url = 'StaffInduction/insertStaff';
				var record = {
					induction_time: this.$props["ruleForm"].induction_time,
					induction_salary: this.$props["ruleForm"].induction_salary,
					trial_start: this.$props["ruleForm"].trial_start,
					trial_end: this.$props["ruleForm"].trial_end,
					is_trial: this.$props["ruleForm"].is_trial,
					induction_date: this.$props["ruleForm"].induction_date,
					trial_salary: this.$props["ruleForm"].trial_salary,
					is_rehire: this.$props["ruleForm"].is_rehire,
					entry_type_id: this.$props["ruleForm"].entry_type_id,
					recruitment_method_id: this.$props["ruleForm"].recruitment_method_id,
					applicant_id: this.$globals.user.id,
					contract_url: this.$props["ruleForm"].contract_url,
					staff: {
						city_id: this.$props["ruleForm"].staff.city_id,
						staff_name: this.$props["ruleForm"].staff.staff_name,
						staff_card: this.$props["ruleForm"].staff.staff_card,
						staff_gender: this.$props["ruleForm"].staff.staff_gender,
						staff_telephone: this.$props["ruleForm"].staff.staff_telephone,
						staff_photo: this.$props["ruleForm"].staff.staff_photo,
						card_photo: this.$props["ruleForm"].staff.card_photo,
						bank_no: this.$props["ruleForm"].staff.bank_no,
						opening_bank: this.$props["ruleForm"].staff.opening_bank,
						bank_photo: this.$props["ruleForm"].staff.bank_photo,
						organize_ids: this.$props["ruleForm"].staff.organize_ids,
						project_id: this.$props["ruleForm"].staff.project_id,
						is_signContract: this.$props["ruleForm"].staff.is_signContract,
						post_id: this.$props["ruleForm"].staff.post_id,
					},

				}
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Return();
					} else {
						this.$message.warning(data);
					}
				}
			},
			//修改
			async Update() {
				var url = 'StaffInduction/update';
				var record = this.$props["ruleForm"];
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Return();
					} else {
						this.$message.warning(data);
					}
				}
			},
			//返回
			Return() {
				this.dialogVisible = false;
				this.dialogAuditorVisible = false;
				this.fileList = [];
				this.$emit("return");
			},
		},
		async created() {
			 // 开户行
			var causeList = await this.$globals.AxiosPost('bank/finds', {});
			this.causeList = causeList.data;
		},
		watch: {
			"ruleForm.contract_url"(newValue) {
				newValue.split(";").forEach((item, index) => {
					if (item != null && item != '') {
						var file = item.split("/");
						this.fileList.push({
							name: file[file.length - 1],
							url: item
						})
					}
				})
			}
		}
	};
</script>

<style scoped>
	>>>.el-radio__input.is-checked .el-radio__inner {
		background-color: #006E4B;
		border-color: #006E4B;
	}

	>>>.el-radio__inner:hover {
		border-color: #006E4B;
	}

	>>>.el-radio__input.is-checked+.el-radio__label {
		color: #006E4B;
	}

	.top {
		font-size: 20px;
		margin-top: 40px;
		margin-left: 40px;
		font-weight: 700;
	}

	.shang h4 {
		margin-top: 30px;
		margin-left: 50px;
		border-left: 3px solid #00724e;
		font-weight: 900;
	}

	.shang1 h4 {
		margin-top: 140px;
		margin-left: 50px;
		border-left: 3px solid #00724e;
		font-weight: 900;
	}

	.el-input {
		width: 400px;
	}

	.name {
		margin-left: -22px;
		margin-bottom: 30px;
	}

	.name1 {
		margin-left: -22px;
		margin-bottom: 30px;
		position: relative;
	}

	.name2 {
		margin-left: -22px;
		margin-top: 130px;
		position: relative;
	}

	.name3 {
		margin-left: -22px;
		margin-top: 50px;
		position: relative;
	}

	.one {
		font-size: 14px;
		margin-right: 10px;
	}

	.tow {
		margin-left: 400px;
	}

	.tow1 {
		margin-left: 850px;
	}

	.btn1 {
		background-color: #00724e;
		color: #fff;
		margin-left: 20px;
		border-radius: 5px;
	}

	.el-button--text {
		width: 130px;
		height: 40px;
		background-color: #00724e;
		color: #fff;
		margin: 0 auto;
		display: block;
	}

	.top1 {
		width: 350px;
		height: 30px;
		margin-left: 0;
		margin-top: 10px;
		border-bottom: 1px solid #ccc;
	}

	.top1 p {
		font-weight: 700;
		font-size: 16px;
		margin-left: 10px;
	}

	.bottom {
		width: 350px;
		height: 90px;
		margin-top: 20px;
	}

	.time {
		font-size: 16px;
		display: block;
		font-weight: 700;
		margin-left: 10px;
	}

	.is {
		font-size: 16px;
		font-weight: 700;
		margin-left: 25px;
	}

	.fp {
		width: 350px;
		border: 1px solid #ccc;
		margin: 0 auto;
	}

	.sp {
		display: block;
		margin: 0 auto;
		margin-left: 85px;
		margin-bottom: 10px;
		font-weight: 700;
	}

	.el-button--primary {
		width: 120px;
		background-color: #00724e;
		color: #fff;
	}

	.el-form-item {
		margin-right: 150px;
	}

	.avatar-uploader>>>.el-upload {
		background-color: #fbfdff;
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader>>>.el-upload:hover {
		border-color: #006E4B;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 148px;
		height: 148px;
		line-height: 148px;
		text-align: center;
	}

	.avatar {
		width: 148px;
		height: 148px;
		display: block;
	}
</style>



// WEBPACK FOOTER //
// Ygrz_add.vue?34c5ba08